module.exports = __webpack_public_path__ + "img/5.80277194.png";